/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_EditionInputs */

const en_field_edition = /** @type {(inputs: Field_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edition`)
};

const es_field_edition = /** @type {(inputs: Field_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edición`)
};

const fr_field_edition = /** @type {(inputs: Field_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Édition`)
};

const de_field_edition = /** @type {(inputs: Field_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgabe`)
};

const ja_field_edition = /** @type {(inputs: Field_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エディション/版`)
};

const zh_field_edition = /** @type {(inputs: Field_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`版本`)
};

const ar_field_edition = /** @type {(inputs: Field_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإصدار`)
};

const id_field_edition = /** @type {(inputs: Field_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edisi`)
};

const it_field_edition = /** @type {(inputs: Field_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edizione`)
};

const ru_field_edition = /** @type {(inputs: Field_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Издание/Версия`)
};

const pt_field_edition = /** @type {(inputs: Field_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edição`)
};

const ko_field_edition = /** @type {(inputs: Field_EditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에디션`)
};

/**
* | output |
* | --- |
* | "Edition" |
*
* @param {Field_EditionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_edition = /** @type {((inputs?: Field_EditionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_EditionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_edition(inputs)
	if (locale === "es") return es_field_edition(inputs)
	if (locale === "fr") return fr_field_edition(inputs)
	if (locale === "de") return de_field_edition(inputs)
	if (locale === "ja") return ja_field_edition(inputs)
	if (locale === "zh") return zh_field_edition(inputs)
	if (locale === "ar") return ar_field_edition(inputs)
	if (locale === "id") return id_field_edition(inputs)
	if (locale === "it") return it_field_edition(inputs)
	if (locale === "ru") return ru_field_edition(inputs)
	if (locale === "pt") return pt_field_edition(inputs)
	return ko_field_edition(inputs)
});